import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ChatbotDataService {
    httpOptions = {
        headers: new HttpHeaders(
            {
                Accept: 'application/json'
            },
        ),
    };
    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    public sendCaseStudies(body): Observable<any> {
        const url = this.apiUrl + 'Project/SendCaseStudies';
        return this.http.post<any>(url, body, this.httpOptions);
    }
}
